import API from "../API";
import { AxiosResponse } from "axios";

export const meGet = async (): Promise<AxiosResponse> => API.get("/auth/me");

// /auth/me/edit -> [PUT}
type MeEditPayload = {
  name: string;
  email: string;
  entityName: string;
};

export const meEdit = async (payload: MeEditPayload): Promise<AxiosResponse> =>
  API.put("/auth/me/edit", payload);
